import browser from '../util/Browser';
// #MODULE - TrackingPixel
// > Author: Michael Moir
// >
// > Create Date: March 11, 2015
// >
// ##DESCRIPTION: This simple module will make an image element.  This img can have a querystring appended to
// its src attribute in order to send data to the webserver.  This is dependent on the web server end point being
// set up to receive and respond to http GET requests.
{
  const $ = require('jquery');
  const globals = require('../util/Globals');
  // STEP: First, est some variables used by the module
  let pagePixelIndex = 0;

  // STEP: This will be the base domain for the pixel.  It is hard coded here.  But we are also checking in Globals
  // for the value.  This way, in the future, should it change, it only need be added to Globals to make the configurable
  const pixelHost = typeof globals.getValue('pixelHost') !== 'undefined' ? globals.getValue('pixelHost') : '//assets.macys.com';
  const pathToPixel = '/navapp/img/spacer.gif';
  const oopsConfig = {
    pathToPixel: '/web20/assets/img/oopsTracker/oopsTracker.gif',
    pixelHost: process.env.ENTRY_POINT === 'mcom' ? '//assets.macys.com' : '//assets.bloomingdales.com',
  };

  // ###Method - track
  // This is the public method to track for a given querystring.  The formatting of the string is the
  // responsibility of the caller.
  // > parameters
  // >
  // + querystring (string) - this is the querystring formatted key/value pairs to track.
  // + options (obj) - this is a generic object to pass in more information. Can be used in future for more
  // parameters.
  //
  // > returns
  // >
  // + boolean true.
  function track(querystring, options) {
    let path = pathToPixel;
    let dom = pixelHost;
    let append = false;

    // STEP: Check the "options" input parameter.  If it is there, then check possible properties and use them if there
    if (typeof options === 'object') {
      path = options.pathToPixel ? options.pathToPixel : path;
      dom = options.pixelHost ? options.pixelHost : dom;
      if (options.append && ((typeof options.append === 'string' && options.append.toLowerCase() === 'true') || options.append === true)) {
        append = true;
      }
    }
    const i = $('<img/>', {
      id: `trk${(pagePixelIndex++).toString()}`,
      class: 'no-stretch',
      width: '1px',
      height: '1px',
      src: `${dom + path}?${querystring}`,
    });

    if (append) {
      $('body').append(i);
    }

    return true;
  }

  const queryBuilder = (options = {}) => {
    const queryOpt = {
      locationUrl: encodeURIComponent(document.location.href),
      referrer: document.referrer ? document.referrer : '-',
      OS: navigator.platform,
      browserNameAndVersion: `${browser.get().browser}And${browser.get().browserVersion}`,
      ...options,
    };
    const formattedQuery = Object.entries(queryOpt).reduce((str, [key, value]) => {
      let formattedStr = str;
      formattedStr += `&${key}=${value}`; return formattedStr;
    }, '');
    return formattedQuery;
  };

  const oopsTracker = (queryOptions, configOptions = oopsConfig) => {
    const queryOpt = queryBuilder(queryOptions);
    return track(queryOpt, configOptions);
  };

  module.exports = {
    track, oopsTracker,
  };
}
